import { debounce } from 'debounce'
import { DashboardHeader } from '@modules/admin/Admin.Header'
import { ProfessionalTable } from '@modules/admin/professionals/Professional.Table'
import FilterBar from '@modules/admin/shared/FiltersBar'
import AccessControl from '@modules/auth/AccessControl'
import CustomPagination from '@modules/tableComponents/Pagination'
import SelectCompanyField from '@modules/formFields/SelectCompanyField'
import SelectProviderField from '@modules/formFields/SelectProviderField'
import SelectSpecialityField from '@modules/formFields/SelectSpecialityField'
import React, { Component } from 'react'
import { withTranslation, Trans } from 'react-i18next'
import { Link } from 'react-router-dom'
import Consultations from '@services/Consultations'
import Loading from '../../core/components/Loading'
import InputField from '../../formFields/InputField'
import { selectRole } from '@modules/auth/auth.Dux'
import { connect } from 'react-redux'

class ProfessionalIndex extends Component {
  state = {
    professionals: null,
    page: null,
    pageSize: 50,
    total: 0,
    isFetching: false,
    search: '',
    companyFilter: [],
    providerFilter: [],
    nameFilter: '',
  }

  clientProfessional = Consultations.professional

  handleChangePage = (page) => {
    return this.setState({ page }, this.fetchProfessionals)
  }

  onTypeSearch = (search) => {
    return this.setState({ search, page: 1 }, this.debouncedFetch)
  }
  fetchProfessionals = () => {
    const { page, pageSize } = this.state
    const filters = {
      search: this.state.search,
      name: this.state.nameFilter || undefined,
      speciality_ids: this.state.specialityFilter ? this.state.specialityFilter.map((sp) => sp.id) : undefined,
      provider_ids: this.state.providerFilter ? this.state.providerFilter.map((prov) => prov.id) : undefined,
      company_api_keys: this.state.companyFilter ? this.state.companyFilter.map((co) => co.api_key) : undefined,
    }

    this.setState({ isFetching: true })

    return this.clientProfessional
      .index({ page, pageSize, ...filters })
      .then((response) => {
        return this.setState({
          professionals: response.data,
          page: response.meta.current_page,
          lastPage: response.meta.last_page,
          isFetching: false,
          total: response.meta.total,
        })
      })
      .catch((err) => {
        this.setState({ isFetching: false, professionals: [] })
        // alert(err.message);
      })
  }
  debouncedFetch = debounce(this.fetchProfessionals, 350, false)

  componentDidMount() {
    this.fetchProfessionals()
  }

  render() {
    const { professionals, isFetching, nameFilter, specialityFilter, companyFilter, providerFilter, total } = this.state
    const { t, role } = this.props
    return (
      <div>
        <DashboardHeader title={<Trans>Profesionales</Trans>} total={total}>
          <AccessControl requiredRole="provider">
            <Link to={`professional/create`} className="btn btn-primary">
              <Trans>Crear</Trans>
            </Link>
          </AccessControl>
        </DashboardHeader>

        <FilterBar onChange={this.onTypeSearch} value={this.state.search}>
          <InputField
            placeholder={t('Nombre')}
            input={{
              value: nameFilter,
              onChange: (e) => this.setState({ nameFilter: e.target.value, page: 1 }),
            }}
          />

          <SelectSpecialityField
            placeholder={t('Especialidades')}
            multi
            input={{
              value: specialityFilter,
              onChange: (speciality) => this.setState({ specialityFilter: speciality, page: 1 }),
            }}
          />

          <AccessControl>
            <SelectCompanyField
              placeholder={t('Compañías')}
              multi
              input={{
                value: companyFilter,
                onChange: (companies) => this.setState({ companyFilter: companies, page: 1 }),
              }}
            />
            <SelectProviderField
              // simpleValue
              placeholder={t('Proveedores')}
              multi
              input={{
                value: providerFilter,
                onChange: (provider) => this.setState({ providerFilter: provider, page: 1 }),
              }}
            />
          </AccessControl>
        </FilterBar>
        <Loading isFetching={isFetching} />

        {professionals && <ProfessionalTable professionals={professionals} role={role} />}

        <CustomPagination
          onClickItem={this.handleChangePage}
          activePage={this.state.page}
          totalPages={this.state.lastPage}
          maxButtons={7}
        />
      </div>
    )
  }
}
const mapStateToProps = (state) => ({
  role: selectRole(state),
})
export default connect(mapStateToProps)(withTranslation()(ProfessionalIndex))
